// const BASE_URL = config.BASE_URL;
// const PATH = config.PATH;


// const params = new URLSearchParams(window.location.search);
// const asset = params.get("id");

const fullPath = window.location.pathname;
// "/example-964-minified-5654cee2-18ac-43fe-bf64-0e9cf6c36783.html"

const asset = fullPath.substring(fullPath.lastIndexOf('/') + 1);

if (!asset) {
    console.error("No 'id' found in URL");
} else {
    // Build S3 URL
    // If PATH exists → `${BASE_URL}/${PATH}/${asset}`
    // If PATH missing → `${BASE_URL}/${asset}`

    const s3Url = `https://robogebra-website.s3.ap-south-1.amazonaws.com/sample-worksheet/${asset}`;
    console.log(s3Url)
    // Load into iframe
    document.getElementById("worksheet-frame").src = s3Url;

    console.log("Loaded:", s3Url);
}
